import { render, staticRenderFns } from "./ModulePage.vue?vue&type=template&id=a894036a&scoped=true"
import script from "./ModulePage.vue?vue&type=script&lang=js"
export * from "./ModulePage.vue?vue&type=script&lang=js"
import style0 from "./ModulePage.vue?vue&type=style&index=0&id=a894036a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a894036a",
  null
  
)

export default component.exports